import { Component, DestroyRef, ViewChild, inject, Inject } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { ServicesService } from 'src/services/services.service';
import { MatSort } from '@angular/material/sort';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface adData {
  ad_id: any;
  data: any;
}

export interface AdElement {
  ad_id: string;
  image_name: string;
  link: string;
  is_active: any;
  created_by: string;
  created_date: string;
  action: any;
}

@Component({
  selector: 'app-advertise',
  templateUrl: './advertise.component.html',
  styleUrls: ['./advertise.component.scss'],
  standalone: false
})
export class AdvertiseComponent {
  displayedColumns: string[] = [
    'ad_id',
    'image_name',
    'link',
    'is_active',
    'created_by',
    'created_date',
    'action',
  ];

  ELEMENT_DATA: AdElement[] = [];
  event_result: any;

  private destoryRef = inject(DestroyRef);

  dataSource = new MatTableDataSource<AdElement>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(private service: ServicesService,
    private router: Router,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog,
  ) { }

  ngAfterViewInit() {
    this.getAdvertise();
    this.dataSource.paginator = this.paginator;
  }

  addAd() {
    const dialogRef = this.dialog.open(AddAdvertiseComponent, {
      data: {
        // user_id: this.user_id
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getAdvertise();
    });
  }

  Edit_Ad(ad_id: any) {
    const dialogRef = this.dialog.open(AddAdvertiseComponent, {
      data: {
        ad_id: ad_id
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getAdvertise();
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  DeleteAd(ad_id: any) {
    const buttonClicked = window.confirm('Are You Sure To Delete This Advertise?');
    if (buttonClicked === true) {
      this.service.delete_advertise(ad_id).pipe(takeUntilDestroyed(this.destoryRef)).subscribe(
        data => {
          this.toastr.success('Advertise Deleted Successfully');
          this.ELEMENT_DATA = this.ELEMENT_DATA.filter(item => item.ad_id !== ad_id);
          this.dataSource.data = this.ELEMENT_DATA;
        });
    }
  }

  onCheckboxChange(element: any) {
    const isActiveValue = element.is_active ? 1 : 0;
    this.active_ad(element.ad_id, isActiveValue);
  }

  active_ad(ad_id: any, isActiveValue: any) {
    this.service.active_ad(ad_id, isActiveValue).subscribe();
  }

  getAdvertise() {
    this.ELEMENT_DATA = [];
    this.spinner.show();
    this.service.get_advertise().pipe(takeUntilDestroyed(this.destoryRef), finalize(() => this.spinner.hide())).subscribe(
      (data: any) => {
        this.event_result = data.data
        for (const item of this.event_result) {
          this.ELEMENT_DATA.push({
            ad_id: item.ad_id,
            link: item.link,
            image_name: `https://aieventzo.com/upload/advertise/` + item.image_name,
            is_active: item.is_active == 1 ? true : false,
            created_by: item.created_by,
            created_date: item.created_date,
            action: item.ad_id
          });
          this.spinner.hide();
        }
        this.dataSource = new MatTableDataSource<AdElement>(this.ELEMENT_DATA);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }

}


@Component({
  selector: 'add-advertise',
  templateUrl: './add-advertise.html',
  styleUrls: ['./advertise.component.scss'],
  standalone: false
})
export class AddAdvertiseComponent {

  addAdForm: FormGroup;
  image_name: any;

  message!: string;
  logofileURL!: string | ArrayBuffer | null;
  logoPath: any;
  isOld1 = false;
  imagefileURL!: any | ArrayBuffer;
  imgType!: any | ArrayBuffer;
  imagePath: any;

  ad_id: any;
  private destoryRef = inject(DestroyRef);
  eventmain: any;
  link: any;

  constructor(
    private member: FormBuilder,
    private addAdservice: ServicesService,
    private dialogRef: MatDialogRef<AddAdvertiseComponent>,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: adData
  ) {
    this.ad_id = data['ad_id'];
    this.addAdForm = this.member.group({
      ad_id: this.ad_id,
      image_name: new FormControl(''),
      link: new FormControl(''),
    });
  }

  ngOnInit(): void {
    this.get_advertise_by_id(this.ad_id);
  }

  get_advertise_by_id(ad_id: any) {
    this.addAdservice.get_advertise_by_id(ad_id).subscribe(
      (data: any) => {
        this.eventmain = data.data;
        this.imagePath = this.eventmain[0].image_name;
        this.link = this.eventmain[0].link;
      });
  }

  previewpimage(files: any) {
    if (files.length === 0) {
      return;
    }
    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = 'Only images are supported.';
      return;
    }
    var reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imagefileURL = reader.result;
      this.imgType = 'advertise';
      this.addAdservice.uploadimage(this.imagefileURL, this.imgType).subscribe((data: any) => {
        this.imagePath = data['image_name'];
      });
    };
  }

  onFormSubmit() {

    this.addAdForm.patchValue({
      image_name: this.imagePath,
    })
    const formData = this.addAdForm.value;

    const hasNonEmptyField = Object.values(formData).some(value => value !== null && value !== '');
    if (this.addAdForm.valid && hasNonEmptyField) {
      if (this.ad_id) {
        this.addAdservice.edit_advertise(this.addAdForm.value).pipe(takeUntilDestroyed(this.destoryRef)).subscribe({
          next: (val: any) => {
            this.toastr.success("Point Updated Succesfully");
            this.dialogRef.close(true);
          },
          error: (err: any) => {
            console.error(err);
          },
        });
      } else {
        this.addAdservice.add_advertise(this.addAdForm.value).pipe(takeUntilDestroyed(this.destoryRef)).subscribe({

          next: (val: any) => {
            this.toastr.success("Point Added Succesfully");
            this.dialogRef.close(true);
          },
          error: (err: any) => {
            console.error(err);
          },
        });
      }
    } else {
      this.toastr.error("Please Fill Required Fields")
    }
  }
}